<template>
  <v-container id="attendance-list">
    <v-form @submit.prevent="onSubmit" ref="form">
      <v-container>
        <h2 class="w-100 text-center title-insert">
          {{ tabId > 0 ? "Editar" : "Adicionar" }} Governança
        </h2>

        <v-row>
          <v-col>
            <v-text-field
              label="Nome"
              name="tipo"
              type="text"
              v-model="governanca.nome"
              required
              :rules="rules"
              background-color="white"
            />
          </v-col>
          <v-col>
            <v-checkbox
              v-model="governanca.possuiMarcoLegal"
              id="atuacao"
              color="primary"
              label="Possui Marco Legal"
            />
          </v-col>
        </v-row>

        <v-textarea
          v-if="governanca.possuiMarcoLegal"
          label="Marco Legal"
          name="marcoLegal"
          type="text"
          v-model="governanca.marcoLegal"
          required
          :rules="rules"
          background-color="white"
        />

        <v-row>
          <v-col v-if="!governanca.responsavelCustomizado">
            <combobox-atores
              :filter="governanca"
              :municipio-id="payload.municipioId"
              :label="'Responsável'"
              :rules="rules"
              :defaultValue="governanca.defaultAtor"
            ></combobox-atores>
          </v-col>
          <v-col v-if="governanca.responsavelCustomizado">
            <v-text-field
              label="Responsável"
              name="observacoes"
              type="text"
              v-model="governanca.responsavel"
              required
              :rules="rules"
              background-color="white"
            />
          </v-col>
          <v-col>
            <v-checkbox
              v-model="governanca.responsavelCustomizado"
              id="atuacao"
              color="primary"
              label="Responsável customizado"
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-checkbox
              v-model="governanca.atuacao"
              id="atuacao"
              color="primary"
              label="Ativo"
            />
          </v-col>
          <v-col>
            <v-checkbox
              v-model="governanca.relevancia"
              id="relevante"
              color="primary"
              label="Relevante"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field
              label="Link"
              name="link"
              type="text"
              v-model="governanca.link"
              required
              :rules="rules"
              background-color="white"
            />
          </v-col>
        </v-row>

        <v-row class="row-buttons mt-4">
          <v-btn
            type="button"
            color="error"
            text
            style="margin-left: 10px"
            @click="goToList()"
          >
            Cancelar
          </v-btn>
          <v-btn color="primary" type="submit"> Salvar </v-btn>
        </v-row>
      </v-container>
    </v-form>
  </v-container>
</template>
<script>
import { mapActions } from "vuex";
import { AppCityHeader } from "@/modules/city";

import { governancaApi } from "../Api/governanca";
import ComboboxAtores from "../../../components/combobox/atores/ComboboxAtores.vue";
export default {
  components: {
    AppCityHeader,
    ComboboxAtores,
  },
  data() {
    return {
      governanca: {},
      payload: {
        municipioId: this.$route.params.id,
      },
      isEdit: false,
      tabType: this.$route.params.tab,
      tabId: this.$route.params.tabId,
      rules: [(v) => !!v || "Campo Obrigatório"],
    };
  },
  mounted() {
    if (this.tabId > 0) {
      this.setLoading(true);
      governancaApi
        .find(this.tabId)
        .then(({ data }) => {
          this.governanca = data;
          this.governanca.possuiMarcoLegal = !!this.governanca.marcoLegal;
          this.governanca.responsavelCustomizado = !this.governanca.atorId;
          (this.governanca.defaultAtor = this.governanca.atorId),
            this.setLoading(false);
        })
        .catch((err) => {
          this.$notification.error("Erro ao encontrar Governança");
          console.log("Erro no mounted ", err);
          this.setLoading(false);
        });
    }
  },
  methods: {
    ...mapActions(["setLoading"]),
    goToList() {
      this.$router.push(
        `/cidade/${this.payload.municipioId}/agenteTerritorial/${this.tabType}`
      );
    },
    async onSubmit() {
      const valid = await this.check();

      if (!valid) return;

      this.governanca = {
        ...this.governanca,
        municipioId: this.payload.municipioId,
        marcoLegal: this.governanca.possuiMarcoLegal
          ? this.governanca.marcoLegal
          : "Sem Marco Legal definido",
        atorId: (this.governanca.ator && this.governanca.ator.idAtor) || 0,
        responsavel:
          this.governanca.ator && this.governanca.ator.idAtor
            ? this.governanca.ator.nome
            : this.governanca.responsavel,
      };

      if (this.tabId > 0) {
        governancaApi
          .update(this.governanca)
          .then(() => {
            this.$notification.success("Governança editado com sucesso!");
            this.goToList();
          })
          .catch((err) => {
            this.$notification.error("Erro ao editar Governança");
            console.log("Erro no submit ", err);
          });
      } else {
        governancaApi
          .create(this.governanca)
          .then(() => {
            this.$notification.success("Governança criado com sucesso!");
            this.goToList();
          })
          .catch((err) => {
            this.$notification.error("Erro ao criar Governança");
            console.log("Erro no submit ", err);
          });
      }
    },
    async check() {
      const isValid = await this.$refs.form.validate();
      return isValid;
    },
  },
};
</script>
<style scoped>
.title-insert {
  color: #5c8bb9;
}
.row-buttons {
  display: flex;
  justify-content: end;
}
</style>
